import AlternateLanguagesContainer from './alternate_languages_container';

export default AlternateLanguagesContainer;
